import { type components } from '@heidi/schema/ml-scribe';
import { useMutation } from '@tanstack/react-query';

import { CONFIRM_EMAIL_CHANGE } from '../../contracts/keys';
import { confirmEmailChange } from '../api/email-change';

export type ConfirmEmailChangeInput = components['schemas']['ConfirmEmailChangeRequest'];
export type ConfirmEmailChangeResponse =
  components['schemas']['ConfirmEmailChangeResponse'];

export interface UseConfirmEmailChangeOptions {
  onSuccess?: (data: ConfirmEmailChangeResponse) => void | Promise<void>;
  onError?: (error: unknown) => void;
}

export function useConfirmEmailChange(options?: UseConfirmEmailChangeOptions) {
  return useMutation({
    mutationKey: [CONFIRM_EMAIL_CHANGE],
    mutationFn: async (data: ConfirmEmailChangeInput) => {
      const response = await confirmEmailChange(data);
      return response.data;
    },
    onSuccess: (data) => options?.onSuccess?.(data),
    onError: (error) => {
      options?.onError?.(error);
    },
  });
}
